import { render, staticRenderFns } from "./PurchasesDeliveryStatusBadge.vue?vue&type=template&id=1efc256a"
import script from "./PurchasesDeliveryStatusBadge.vue?vue&type=script&lang=js"
export * from "./PurchasesDeliveryStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports